import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import fullLogo from "../../assets/Images/fullLogo.png";
import { menuOptions } from './SideMenu';

const NESTED_ACTIVE_PATHS = ['/admin/notifications', '/admin/groups'];

const SideBar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeItem, setActiveItem] = useState(location.pathname);

    const handleMenuClick = (path: any) => {
        navigate(path);
    };

    useEffect(() => {
        setActiveItem(location?.pathname)
    }, [location])

    return (
        <>
            <Box className="sidebar" sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
                <Box
                    className="p-3 sidebar-logo"
                    sx={{ flexShrink: 0 }}
                >
                    <img src={fullLogo} alt='Wolfpack Logo' style={{ maxWidth: '150px' }} />
                </Box>

                <Box
                    sx={{
                        color: '#898989',
                        fontSize: '12px',
                        fontWeight: '400',
                        padding: 2,
                        letterSpacing: '1px',
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'start',
                        pl: 5,
                        flexShrink: 0,
                    }}
                >
                    MAIN MENU
                </Box>
                <Box className="p-0" sx={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>

                    <List className='d-flex gap-2 p-0 flex-column w-100'>
                        {menuOptions.map((option) => {
                            const IconComponent = option.icon;
                            const isActive = activeItem === option.path ||
                                (NESTED_ACTIVE_PATHS.includes(option.path) && activeItem.startsWith(option.path + '/'));

                            return (
                                <ListItem className='ps-2'
                                    key={option.id}
                                    disablePadding
                                >
                                    <ListItemButton className='d-flex gap-2 ps-2'
                                        onClick={() => handleMenuClick(option.path)}
                                        sx={{
                                            borderTopLeftRadius: '15px',
                                            borderBottomLeftRadius: '15px',
                                            color: isActive ? '#fff' : '#fff',
                                            backgroundColor: isActive ? '#2c2c2c' : 'transparent',
                                            '&:hover': {
                                                backgroundColor: isActive ? '#2c2c2c' : '#2c2c2c',
                                            },
                                        }}
                                    >
                                        <ListItemIcon
                                            sx={{
                                                minWidth: '40px',
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '10px',
                                                    backgroundColor: isActive ? '#F2674A' : 'transparent',
                                                    transition: 'background-color 0.3s ease',
                                                }}
                                            >
                                                <IconComponent />
                                            </Box>
                                        </ListItemIcon>
                                        <ListItemText sx={{ color: isActive ? '#F2674A' : '#fff' }}
                                            primary={option.label}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            );
                        })}
                    </List>
                </Box>
            </Box>
        </>
    );
};

export default SideBar;